import { render, staticRenderFns } from "./FollowForm.vue?vue&type=template&id=856cefb4&"
import script from "./FollowForm.vue?vue&type=script&lang=js&"
export * from "./FollowForm.vue?vue&type=script&lang=js&"
import style0 from "./FollowForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FollowForm.vue"
export default component.exports